import { render } from "./MmLogin.vue?vue&type=template&id=5f2b0982"
import script from "./MmLogin.vue?vue&type=script&lang=js"
export * from "./MmLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__